import script from "./Bingli.vue?vue&type=script&setup=true&lang=js"
export * from "./Bingli.vue?vue&type=script&setup=true&lang=js"

import "./Bingli.vue?vue&type=style&index=0&id=41a9d36b&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a9d36b"]])

export default __exports__